import { observable } from "mobx";
import InternalTransferApprovalType from "./internalTransferApprovalType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalTransferApprovalResponse {
  id!: string;

  @observable
  approvalType!: InternalTransferApprovalType;
}
